// Onboarding answer collection.
//
// During the (account-less) onboarding flow we keep answers in sessionStorage so they
// survive refreshes and the hop over to the signup page. The moment an account is
// created (email or Google), persistOnboardingToUser(uid) writes them to Firestore at
// users/{uid}.onboarding and sets onboardingComplete, then clears the local copy.

import { doc, setDoc, serverTimestamp } from 'firebase/firestore'
import { db } from '../config/firebase.js'

const KEY = 'autoinvent_onboarding'

export function getOnboarding() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || '{}')
  } catch {
    return {}
  }
}

export function setOnboarding(patch) {
  const next = { ...getOnboarding(), ...patch }
  sessionStorage.setItem(KEY, JSON.stringify(next))
  return next
}

export function clearOnboarding() {
  sessionStorage.removeItem(KEY)
}

export function hasOnboarding() {
  const o = getOnboarding()
  return o && Object.keys(o).length > 0
}

// Write the collected answers onto a freshly-created user, once. Safe to call on every
// signup path — it no-ops when there's nothing stored. Uses merge so it never clobbers
// other user fields.
export async function persistOnboardingToUser(uid) {
  if (!uid || !db) return
  const answers = getOnboarding()
  if (!answers || Object.keys(answers).length === 0) return
  try {
    await setDoc(
      doc(db, 'users', uid),
      {
        onboarding: { ...answers, completedAt: serverTimestamp(), version: 1 },
        onboardingComplete: true,
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    )
    clearOnboarding()
  } catch (err) {
    console.error('Failed to persist onboarding answers:', err)
  }
}
